import React from 'react';
import { NavLink } from 'react-router-dom';

const Navbar = (props) => {

  const style = `
    .nav-link {
      position: relative;
      text-decoration: none;
    }

    .nav-link::after {
      content: '';
      position: absolute;
      width: 0;
      height: 2px;
      bottom: 0;
      left: 0;
      background-color: ${props.navColor};
      transition: width 0.3s ease;
    }

    .nav-link:hover::after {
      width: 100%;
    }

    .active-link {
      color: ${props.navColor} !important;
    }

    .active-link::after {
      width: 100%;
      background-color: ${props.navColor};
    }
  `;

  return (
    <>
      <style>{style}</style>

      <nav className={`navbar navbar-expand-lg navbar-${props.buttonColor} position-${props.position}`} style={{ zIndex: 100,width:"100%" }}>
        <div className={`container mx-md-5 border-${props.border}`}>
          <NavLink className="navbar-brand logo w-50" to="/">
            <img
              src={props.logo}
              alt="Logo"
              style={{ width: '50%' }}
              className="logo-img"
            />
          </NavLink>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="collapsibleNavbar">
            <ul className="navbar-nav ms-auto mt-2">
              <li className="nav-item me-4">
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    `nav-link text-${props.color} ${isActive ? 'active-link' : ''}`
                  }
                >
                  Home
                </NavLink>
              </li>
              <li className="nav-item me-4">
                <NavLink
                  to="/form"
                  className={({ isActive }) =>
                    `nav-link text-${props.color} ${isActive ? 'active-link' : ''}`
                  }
                >
                  FARMS
                </NavLink>
              </li>
               <li className="nav-item me-4">
                <NavLink
                  to="/kookal"
                  className={({ isActive }) =>
                    `nav-link text-${props.color} ${isActive ? 'active-link' : ''}`
                  }
                >
                  Kookal
                </NavLink>
              </li>
              <li className="nav-item me-4">
                <a className={`nav-link text-${props.color}`} href="https://booking.avothar.com/" target='blank' rel="noreferrer">
                  STAYS
                </a>
              </li>
              {/* <li className="nav-item me-4">
                <a className={`nav-link text-${props.color}`} href="#third-section">
                  ACTIVITIES
                </a>
              </li> */}
              <li className="nav-item me-4">
                <NavLink
                  to="/about"
                  className={({ isActive }) =>
                    `nav-link text-${props.color} ${isActive ? 'active-link' : ''}`
                  }
                >
                  ABOUT
                </NavLink>
              </li>
              <li className="nav-item me-4">
                <NavLink
                  to="/contact"
                  className={({ isActive }) =>
                    `nav-link text-${props.color} ${isActive ? 'active-link' : ''}`
                  }
                >
                  CONTACT
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
